import LanguageSupport from "../../../../src/mdx/optional-settings/language-support.mdx";
import * as React from 'react';
export default {
  LanguageSupport,
  React
};